(function () {
  var cfg = window.mzSettings || {};

  function rate() {
    return (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate)) || 1;
  }

  function formatMoney(cents) {
    var fmt = cfg.moneyFormat || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var noDecimals = Math.round(cents / 100).toString();
    var withCommas = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, withCommas)
      .replace(/<[^>]*>/g, '');
  }

  function thresholds() {
    var r = rate();
    var ship = cfg.freeShipping || 9900;
    if (cfg.freeShippingInShopCurrency) ship = Math.round(ship * r);
    var gift = cfg.freeGift || 15000;
    if (cfg.freeGiftInShopCurrency) gift = Math.round(gift * r);
    return { ship: ship, gift: gift };
  }

  function render(total) {
    var t = thresholds();
    document.querySelectorAll('[data-mz-progress]').forEach(function (el) {
      var msg = el.querySelector('[data-mz-progress-msg]');
      var fill = el.querySelector('[data-mz-progress-fill]');
      var marks = el.querySelectorAll('[data-mz-mark]');
      var text;
      if (total < t.ship) {
        text = (el.dataset.shipMsg || '').replace('[amount]', '<strong>' + formatMoney(t.ship - total) + '</strong>');
      } else if (total < t.gift) {
        text = (el.dataset.giftMsg || '').replace('[amount]', '<strong>' + formatMoney(t.gift - total) + '</strong>');
      } else {
        text = el.dataset.doneMsg || '';
      }
      if (msg) msg.innerHTML = text;
      if (fill) fill.style.width = Math.min(100, (total / t.gift) * 100) + '%';
      marks.forEach(function (m) {
        var need = m.dataset.mzMark === 'gift' ? t.gift : t.ship;
        m.classList.toggle('is-done', total >= need);
        var lab = m.querySelector('[data-mz-mark-amount]');
        if (lab) lab.textContent = formatMoney(need).replace(/\.00$/, '');
      });
      el.hidden = false;
    });
  }

  function refresh() {
    if (!document.querySelector('[data-mz-progress]')) return;
    fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var goods = cart.items_subtotal_price || 0;
        (cart.items || []).forEach(function (i) { if ((i.properties && i.properties._mz_gift) || /shipping protection/i.test(i.product_title || '')) goods -= i.final_line_price; });
        render(goods);
      })
      .catch(function () {});
  }

  var _fetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0] && (arguments[0].url || arguments[0]);
    var p = _fetch.apply(this, arguments);
    if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { setTimeout(refresh, 250); });
    }
    return p;
  };

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-mz-progress]').forEach(function (el) {
      if (el.dataset.cartTotal) render(parseInt(el.dataset.cartTotal, 10));
    });
    refresh();
    initSticky();
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  function initSticky() {
    var bar = document.querySelector('[data-mz-sticky-atc]');
    if (!bar) return;
    var section = bar.closest('section, .shopify-section') || document;
    var form = document.querySelector('product-form form[action*="/cart/add"]');
    if (!form) return;
    var realBtn = form.querySelector('.product-form__submit') || form.querySelector('[type="submit"]');
    if (!realBtn) return;
    var watchEl = form.closest('.product-form') || form;
    var priceEl = bar.querySelector('[data-mz-sticky-price]');
    var stickyBtn = bar.querySelector('[data-mz-sticky-btn]');

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var below = entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', !entry.isIntersecting && below);
        bar.setAttribute('aria-hidden', !(!entry.isIntersecting && below));
      });
    });
    io.observe(watchEl);

    function sync() {
      var livePrice = document.querySelector('[id^="price-template"] .price-item--last, [id^="price-template"] .price-item--regular');
      if (livePrice && priceEl) priceEl.textContent = livePrice.textContent.trim();
      if (stickyBtn) {
        stickyBtn.disabled = realBtn.disabled;
        stickyBtn.textContent = realBtn.disabled ? (realBtn.textContent || '').trim() : stickyBtn.dataset.label;
      }
    }
    sync();
    new MutationObserver(sync).observe(form, { subtree: true, attributes: true, childList: true });

    stickyBtn.addEventListener('click', function () {
      if (realBtn.disabled) {
        realBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      realBtn.click();
    });
  }
})();

(function () {
  function init(root) {
    var track = root.querySelector('[data-mz-track]');
    var slides = track ? track.children : [];
    if (!track || slides.length < 2) return;
    var dots = root.querySelectorAll('[data-mz-dot]');
    var idx = 0, timer = null, secs = parseInt(root.dataset.autoplay || '0', 10);
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function go(i) { idx = (i + slides.length) % slides.length; track.scrollTo({ left: idx * track.clientWidth, behavior: 'smooth' }); }
    function mark() {
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      idx = i;
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); d.setAttribute('aria-selected', k === i); });
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() { stop(); if (secs > 0 && !reduce) timer = setInterval(function () { go(idx + 1); }, secs * 1000); }
    var t; track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(mark, 60); }, { passive: true });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.dataset.mzDot, 10)); start(); }); });
    var p = root.querySelector('[data-mz-prev]'), n = root.querySelector('[data-mz-next]');
    if (p) p.addEventListener('click', function () { go(idx - 1); start(); });
    if (n) n.addEventListener('click', function () { go(idx + 1); start(); });
    ['pointerdown', 'focusin', 'mouseenter'].forEach(function (e) { root.addEventListener(e, stop, { passive: true }); });
    root.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
    start();
  }
  document.addEventListener('DOMContentLoaded', function () { document.querySelectorAll('[data-mz-slides]').forEach(init); });
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-mz-slides]'); if (r) init(r); });
})();

/* Recent sales pop-up (real orders only) */
(function () {
  var root = document.querySelector('[data-mz-pop]');
  if (!root) return;
  var ss = {
    get: function (k) { try { return sessionStorage.getItem('mzpop:' + k); } catch (e) { return null; } },
    set: function (k, v) { try { sessionStorage.setItem('mzpop:' + k, v); } catch (e) {} }
  };
  if (ss.get('off')) return;
  var mobile = window.matchMedia('(max-width: 749px)').matches;
  var d = root.dataset;
  var cfg = {
    first: (+(mobile ? d.mFirst : d.dFirst) || 10) * 1000,
    gap: (+(mobile ? d.mGap : d.dGap) || 40) * 1000,
    max: +(mobile ? d.mMax : d.dMax) || 6,
    show: (+d.show || 6) * 1000,
    maxAge: ((+d.maxDays || 3) + 1) * 86400000
  };
  var link = root.querySelector('[data-mz-pop-link]');
  var list = [], timer = null, hideTimer = null;

  function ago(t) {
    var mins = Math.max(1, Math.floor((Date.now() - t) / 60000));
    if (mins < 60) return mins + (mins === 1 ? ' minute ago' : ' minutes ago');
    var hrs = Math.floor(mins / 60);
    if (hrs < 24) return hrs + (hrs === 1 ? ' hour ago' : ' hours ago');
    var days = Math.floor(hrs / 24);
    return days + (days === 1 ? ' day ago' : ' days ago');
  }
  function blocked() {
    if (document.hidden) return true;
    var up = document.querySelector('#CartPopup, .upcart-cart');
    if (up && up.offsetParent !== null) {
      var r = up.getBoundingClientRect();
      if (r.width > 0 && r.left < window.innerWidth - 10 && r.right > 10) return true;
    }
    if (document.querySelector('cart-drawer.active, .menu-drawer-container[open], .search-modal[open], details[open] > .search-modal')) return true;
    return false;
  }
  function count() { return +(ss.get('count') || 0); }
  function schedule(delay) {
    clearTimeout(timer);
    if (count() >= cfg.max) return;
    timer = setTimeout(show, Math.max(1000, delay));
  }
  function show() {
    if (!list.length || count() >= cfg.max) return;
    if (blocked()) return schedule(8000);
    var i = (+(ss.get('idx') || 0)) % list.length;
    var s = list[i];
    link.href = s.u;
    root.querySelector('[data-mz-pop-img]').src = s.im || '';
    root.querySelector('[data-mz-pop-img]').alt = s.ti;
    root.querySelector('[data-mz-pop-who]').textContent = s.n + ' in ' + s.c + (s.r ? ', ' + s.r : '');
    root.querySelector('[data-mz-pop-title]').textContent = s.ti;
    root.querySelector('[data-mz-pop-time]').textContent = 'Purchased ' + ago(s.ts) + (mobile ? '' : ' · ' + s.pr);
    root.hidden = false;
    requestAnimationFrame(function () { root.classList.add('is-visible'); });
    ss.set('idx', String(i + 1));
    ss.set('count', String(count() + 1));
    ss.set('last', String(Date.now()));
    (window.dataLayer = window.dataLayer || []).push({ event: 'mz_sales_pop_view', mz_product: s.ti });
    clearTimeout(hideTimer);
    hideTimer = setTimeout(hide, cfg.show);
    schedule(cfg.gap);
  }
  function hide() {
    root.classList.remove('is-visible');
    setTimeout(function () { if (!root.classList.contains('is-visible')) root.hidden = true; }, 400);
  }
  root.addEventListener('mouseenter', function () { clearTimeout(hideTimer); });
  root.addEventListener('mouseleave', function () { hideTimer = setTimeout(hide, 2500); });
  link.addEventListener('click', function () {
    (window.dataLayer = window.dataLayer || []).push({ event: 'mz_sales_pop_click', mz_product: root.querySelector('[data-mz-pop-title]').textContent });
  });
  root.querySelector('[data-mz-pop-close]').addEventListener('click', function () {
    ss.set('off', '1'); clearTimeout(timer); hide();
  });

  function start(data) {
    var now = Date.now();
    list = (data || []).map(function (s) { s.ts = Date.parse(s.t); return s; })
      .filter(function (s) { return s.ts && now - s.ts < cfg.maxAge && now - s.ts > -3600000; })
      .sort(function (a, b) { return b.ts - a.ts; });
    if (!list.length) return;
    var last = +(ss.get('last') || 0);
    var wait = last ? Math.max(cfg.first, cfg.gap - (now - last)) : cfg.first;
    schedule(wait);
  }
  var cached = ss.get('feed'), cachedAt = +(ss.get('feedAt') || 0);
  if (cached && Date.now() - cachedAt < 5 * 60000) {
    try { start(JSON.parse(cached)); return; } catch (e) {}
  }
  fetch(d.feed, { credentials: 'same-origin' })
    .then(function (r) { return r.json(); })
    .then(function (data) { ss.set('feed', JSON.stringify(data)); ss.set('feedAt', String(Date.now())); start(data); })
    .catch(function () {});
})();

/* "Mossify" in titles → official Cooper Black wordmark */
(function () {
  var SEL = 'h1, h2, .h1, .h2, .mz-buyer-cta__title, .footer-block__heading, .mz-site__title, .mz-fcta__title, .mz-rt__card h3, .mz-press__feature-copy h3';
  var SKIP = '.mz-qo, .card__heading, .card-information, [data-mz-wm-skip], script, style, a.mz-stores__item';
  function run(scope) {
    (scope || document).querySelectorAll(SEL).forEach(function (el) {
      if (el.closest(SKIP) || el.dataset.mzWm) return;
      el.dataset.mzWm = '1';
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), nodes = [];
      while (walker.nextNode()) if (/\bmossify\b/i.test(walker.currentNode.nodeValue)) nodes.push(walker.currentNode);
      nodes.forEach(function (n) {
        var parts = n.nodeValue.split(/(\bmossify\b)/i), frag = document.createDocumentFragment();
        parts.forEach(function (p) {
          if (/^mossify$/i.test(p)) { var s = document.createElement('span'); s.className = 'mz-wm'; s.innerHTML = '<span class="visually-hidden">Mossify</span>'; frag.appendChild(s); }
          else if (p) frag.appendChild(document.createTextNode(p));
        });
        n.parentNode.replaceChild(frag, n);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); }); else run();
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();

